import {Component} from '@angular/core';

@Component({
  selector: 'logo',
  template: `
  <ng-content></ng-content>
  `
})
export class LogoComponent {

}



// WEBPACK FOOTER //
// ./src/app/typescripts/free/navbars/logo.component.ts